import { jsx as _jsx } from "react/jsx-runtime";
import { Check } from "@air/next-icons";
import { DropdownMenu, renderDropdownItems } from "@air/primitive-dropdown-menu";
import { CustomFieldModalColorMenuTrigger } from "~/components/CustomFields/CustomFieldModal/CustomFieldModalForm/CustomFieldModalColorMenuTrigger";
import { CUSTOM_FIELD_MODAL_OPTION_COLOR_OPTION } from "~/constants/testIDs";
const CustomFieldModalColorMenu = (param)=>{
    let { selectedColor, index, handleColorClick, colors, fontHex } = param;
    const menuOptions = colors.map((color)=>{
        var _color_backgroundHex;
        return {
            id: color.id,
            label: color.name,
            prefix: /*#__PURE__*/ _jsx("div", {
                className: "mr-2 size-6 rounded-4",
                style: {
                    backgroundColor: color.backgroundHex
                },
                "data-testid": "".concat(CUSTOM_FIELD_MODAL_OPTION_COLOR_OPTION, "-").concat(color.name)
            }),
            onSelect: ()=>handleColorClick(color.backgroundHex, index),
            suffix: ((_color_backgroundHex = color.backgroundHex) === null || _color_backgroundHex === void 0 ? void 0 : _color_backgroundHex.toLowerCase()) === (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.toLowerCase()) ? /*#__PURE__*/ _jsx(Check, {
                className: "size-4"
            }) : null,
            type: "item"
        };
    });
    return /*#__PURE__*/ _jsx(DropdownMenu, {
        size: "small",
        trigger: /*#__PURE__*/ _jsx(CustomFieldModalColorMenuTrigger, {
            selectedColor: selectedColor,
            fontHex: fontHex
        }),
        children: renderDropdownItems({
            options: menuOptions
        })
    });
};
export { CustomFieldModalColorMenu };
